// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__F8OfL","detailsBorder":"styles_detailsBorder__3tkzn"};